import { apiClient } from '@/utils/api-client'

const API_INTERNAL_BASE = '/projects'

/**
 * Project environment service for managing environments.
 */
class ProjectEnvironmentService {
    /**
     * Create a new environment for a project.
     *
     * @param {string} projectKey - Project key
     * @param {Object} form - Environment payload
     * @returns {Promise<Object>} Created environment response
     */
    async create(projectKey, form) {
        return await apiClient
            .post(API_INTERNAL_BASE + '/' + projectKey + '/environments', form)
            .then((response) => {
                return response.data
            })
    }

    /**
     * Remove an environment from a project.
     *
     * @param {string} projectKey - Project key
     * @param {string} environmentKey - Environment key
     * @returns {Promise<Object>} Removal response
     */
    async remove(projectKey, environmentKey) {
        return await apiClient
            .delete(
                API_INTERNAL_BASE +
                    '/' +
                    projectKey +
                    '/environments/' +
                    environmentKey
            )
            .then((response) => {
                return response.data
            })
    }

    /**
     * List environments for a project.
     *
     * @param {string} projectKey - Project key
     * @returns {Promise<Object>} Environments list response
     */
    async list(projectKey) {
        return await apiClient
            .get(API_INTERNAL_BASE + '/' + projectKey + '/environments')
            .then((response) => {
                return response.data
            })
    }

    /**
     * Update an environment.
     *
     * @param {string} projectKey - Project key
     * @param {string} environmentKey - Environment key
     * @param {Object} form - Update payload
     * @returns {Promise<Object>} Update response
     */
    async update(projectKey, environmentKey, form) {
        return await apiClient
            .put(
                API_INTERNAL_BASE +
                    '/' +
                    projectKey +
                    '/environments/' +
                    environmentKey,
                form
            )
            .then((response) => {
                return response.data
            })
    }
}

export default new ProjectEnvironmentService()
